'use strict'

//import * as polybool from 'polybooljs';
// import { Edge, trapezoidation } from './polygonTrapezoidation';

import {
    intersectLinePolygon, rotatePoint, rotatePolygon, polygonBuffer,
    simplifyAndNormalizePolygon, ringToGeojsonPolygon, intersectLineSegment,
    closestPointInSegment, distanceAroundPolygon, closestPointInPolygon2,
    simplifyRoute, polylineToGeojsonLineString, computeAreas, pointFromEndOfLine,
    distToPolygonSquared, GetPolygonLongestSide, distToSegmentSquared, polygonArea,
    isXMonotone, SubtractExclusionAreas, buildAdjacencyGraph, closestPointInArray,
    simplePolygonBuffer, removeNearPoints, distancePointPoint
} from './geometry';

import SubfieldsSequence from './SubfieldsSequence.js';

import Coordinate  from 'jsts/org/locationtech/jts/geom/Coordinate';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
import GeometryCollection from 'jsts/org/locationtech/jts/geom/GeometryCollection'; 
import {BufferOp, BufferParameters} from 'jsts/org/locationtech/jts/operation/buffer';
//import PrecisionModel from 'jsts/org/locationtech/jts/geom/PrecisionModel'; 
//import GeometryPrecisionReducer from 'jsts/org/locationtech/jts/precision/GeometryPrecisionReducer';
import GeometrySnapper from 'jsts/org/locationtech/jts/operation/overlay/snap/GeometrySnapper';

import {fromLatLonArray, fromLatLon, toLatLonArray2 } from '../utils/utm';
import routeplannerSingleOpenField from './routeplannerSingleOpenField';
//import getSubfields from './getSubfields';
//import routePlanner from './routePlanner';
import getSubfields3 from './getSubfields3';
//import { Endpoint } from 'aws-sdk';

import {headlandPolylineToRoute, removePolylineShortEdges} from './routeplannerSingleOpenField.js'

//import {connectedComponents } from 'graphology-components';
//import {Graph} from 'graphology';

//var simplepolygon = require('simplepolygon');


export default function routeplannerOpenField(params){

    var res = validateParams(params);

    if (res!= null){
        return res;
    }


    var fieldPolygon = params.fieldPolygon;
    var obstacles = params.obstacles;
    var turningRadius = params.turningRadius; // (m)
    var workingWidth = params.workingWidth; // (m)
    var workingSpeed = params.workingSpeed; // (m/s)
    var maxHeadlandCircuits = params.headlandCircuits; // (N) 
    var workingAngle = params.workingAngle;
    var fieldEntrance = params.fieldEntrance;
    var internalPattern = params.internalPattern;
    var patternStart = params.patternStart;
    var turnOffset = params.turnOffset;
    var turningSpeedPercentage = params.turningSpeedPercentage;
    var fullConcaveTurns = params.fullConcaveTurns; // boolean
    var circuitTurnsMinimumAngle = params.circuitTurnsMinimumAngle; // degrees
    var subdivide = params.subdivide; // boolean
    var decreaseCircuitsAutomatically = params.decreaseCircuitsAutomatically; // boolean
    var increaseCircuitsAutomatically = params.increaseCircuitsAutomatically; // boolean
    var includeEntranceToStart = params.includeEntranceToStart; // boolean
    var includeEndToEntrance = params.includeEndToEntrance; // boolean


    var turningSpeed = turningSpeedPercentage*workingSpeed/100;

    ///var utmEntrance = fromLatLon(fieldEntrance[1], fieldEntrance[0]);

    // compute headlandWidth according to number of swaths
    ///var headlandWidth = headlandSwaths * workingWidth;

    /* each polygon coordinates in Cesium format [lon,lat,lon,lat...]
    / first polygon: outer border - following polygons: holes

    polygonslatlon = [
        [-58.014035224914544,-34.94903469588605,-58.01261901855469,-34.95084624366132,-58.00973296165466,-34.9508726251293,-58.008756637573235,-34.949412837805205,-58.00855278968811,-34.94821684809537,-58.009260892868035,-34.94914901804555,-58.00969004631043,-34.947654023371236,-58.01260828971862,-34.947645229204255],
        [-58.0133056640625,-34.94906107793701,-58.012522459030144,-34.950098765207045,-58.01255464553833,-34.948383935941564],
        [-58.01321983337402,-34.94857740565382,-58.013198375701904,-34.94875328681423,-58.01301598548889,-34.948656552222694,-58.013026714324944,-34.94852464123212]
    ];
    */

/* BORRAR 

const pls = [
  {
    "polygon": [
      {
        "x": 540807.011901416,
        "y": 5845800.151606713
      },
      {
        "x": 541142.6680531983,
        "y": 5845915.727288343
      },
      {
        "x": 541139.8118049795,
        "y": 5845861.881528269
      },
      {
        "x": 541110.341068909,
        "y": 5845793.74631143
      },
      {
        "x": 541287.1314952672,
        "y": 5845783.028318826
      },
      {
        "x": 541256.6971362018,
        "y": 5845701.625080012
      },
      {
        "x": 541310.143510852,
        "y": 5845690.962175523
      },
      {
        "x": 541402.351787102,
        "y": 5845697.301381606
      },
      {
        "x": 541382.8073267872,
        "y": 5845511.500081013
      },
      {
        "x": 541231.1800244749,
        "y": 5845564.684071764
      },
      {
        "x": 541064.9540356101,
        "y": 5845635.52830102
      },
      {
        "x": 540806.206550348,
        "y": 5845736.712144639
      }
    ],
    "workingAngle": 0
  },
  {
    "polygon": [
      {
        "x": 541024.7961494162,
        "y": 5845946.050385456
      },
      {
        "x": 541024.8657321204,
        "y": 5845946.052815337
      },
      {
        "x": 541137.1952394164,
        "y": 5845913.842847436
      },
      {
        "x": 541013.8294415255,
        "y": 5845871.364596686
      },
      {
        "x": 541013.7083602216,
        "y": 5845871.360368434
      }
    ],
    "workingAngle": 5
  }
];

const sarasa1 = buildAdjacencyGraph(pls, 1);

*/


    var polygonsUtm = [];

    for(var k=0; k < fieldPolygon.length; k++)
    {
        // fill exclusion areas with polygons in UTM coordinates

        var utmPoly = fromLatLonArray(fieldPolygon[k]);

        // simplify polygon
        var geoJsonPoly = ringToGeojsonPolygon(utmPoly);
        var sp = simplifyAndNormalizePolygon(geoJsonPoly, 0.5);

        polygonsUtm.push(sp);
    }

    var obstaclesUtm = [];
    for(var k=0; k < obstacles.length; k++)
    {
        var utmPoly = fromLatLonArray(obstacles[k]);

        // simplify polygon
        //var geoJsonPoly = ringToGeojsonPolygon(utmPoly);
        //var sp = simplifyAndNormalizePolygon(geoJsonPoly, 0.5);

        obstaclesUtm.push(utmPoly);
    }


    if (fieldPolygon.length>1){

        var multipolygon = SubtractExclusionAreas(polygonsUtm);

        if (multipolygon.length>1){  

            const error = {
                timestamp: new Date().toISOString(),
                errorCode: 'E006',
                message: 'The exclusion areas have split the field into multiple parts.',
                details: "The exclusion areas have divided the field into two or more separate polygons. Please ensure that the field remains a single boundary polygon after subtracting the exclusion zones.\n"
            };
    
            return error;    
        }

        polygonsUtm = [...multipolygon[0]];   // clone array  

    }

    //* lo cambio a partir de considerar obstacles. Chequear el tamaño de cada area de exc

    if (polygonsUtm.length>1 && !subdivide ){  // The field must be subdivided because it has exclusion areas, or the user wants to subdivide it
        
        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E007',
            message: 'The field contains exclusion areas and needs to be subdivided.',
            details: "This field includes exclusion areas that require it to be split into separate subfields. Please use the 'Divide into Subfields' option to correctly process the field.\n"
        };

        return error;    
    }
    //*/

    // Analyze exclusion areas
    //var large_exc_areas = 0;
    //var obstacles = 0;
    //if (polygonsUtm.length>1){



    //}


    var utmEntrance = fromLatLon(fieldEntrance[1], fieldEntrance[0]);
    var zNum = utmEntrance.zoneNum;
    var zLet = utmEntrance.zoneLetter;

    if (!subdivide){

/*        
        headlandSwaths = calculateNumberOfCircuits(polygonsUtm[0], headlandSwaths, workingWidth);
        if (headlandSwaths==0){
            return {error: "There is not enough space to generate a route"};
        }
*/

        // check if the value is a numeric value passed as string and change it to numeric
        if (typeof (workingAngle) == 'string' && workingAngle!="LONGEST_SIDE" && workingAngle!="OPTIMAL"){

            workingAngle = Number(workingAngle);
            
        }

/*
        if (typeof (workingAngle) == 'string') {

            switch (workingAngle) {

                case "LONGEST_SIDE":
                    workingAngle = GetPolygonLongestSide(polygonsUtm[0]);
                    if (!isMonotone(polygonsUtm[0], headlandSwaths, workingWidth, workingAngle)){
                        return {error: "The boundary of the field is not monotone with respect to the line of the longest side (that is, all lines parallel to the working direction must intersect the field boundary polygon only at two points). Try 'Optimal' option for working angle"};
                    }
                    break;

                case "OPTIMAL":

                    workingAngle = calculateOptimalWorkingAngle(polygonsUtm[0], headlandSwaths, workingWidth);
                    if (workingAngle == null){
                        return {error: "Could not find a working angle with respect to which the field boundary is monotone (that is, all lines parallel to the working direction must intersect the field boundary polygon only at two points). Try selecting the 'Subdivide' option"};
                    }

                    break;
            }
        }
*/            
/*        
        else{ // the parameter 'workingAngle' was specified as a number
            
            if (!isMonotone(polygonsUtm[0], headlandSwaths, workingWidth, workingAngle)){
                return {error: "The field boundary is not monotone with respect to the specified working angle (that is, all lines parallel to the working direction must intersect the field boundary polygon only at two points). Try 'Optimal' option for working angle"};
            }
        }
*/
        // call SingleOpenField method
        var params2=[];
        params2.polygonsUtm = polygonsUtm;
        params2.obstaclesUtm = obstaclesUtm;
        params2.turningRadius = params.turningRadius; // (m)
        params2.workingWidth = params.workingWidth; // (m)
        params2.workingSpeed = params.workingSpeed; // (m/s)
        params2.maxHeadlandCircuits = maxHeadlandCircuits; // (N) 
        params2.workingAngle = workingAngle;
        params2.utmEntrance = utmEntrance;
        params2.internalPattern = params.internalPattern;
        params2.patternStart = params.patternStart;
        params2.turnOffset = params.turnOffset;
        params2.turningSpeedPercentage = params.turningSpeedPercentage;
        params2.fullConcaveTurns = params.fullConcaveTurns; // boolean
        params2.circuitTurnsMinimumAngle = params.circuitTurnsMinimumAngle; // degrees
        params2.decreaseCircuitsAutomatically = params.decreaseCircuitsAutomatically; // boolean
        params2.increaseCircuitsAutomatically = params.increaseCircuitsAutomatically; // boolean
        params2.includeEntranceToStart = params.includeEntranceToStart; // boolean
        params2.includeEndToEntrance = params.includeEndToEntrance; // boolean


        //return routeplannerSingleOpenField(params2);


        try {
            const r = routeplannerSingleOpenField(params2);
            if (r.errorCode) {
                return r;
            }
            else {
                const routePlan = calculateRouteStats(r, params2.workingWidth, params2.polygonsUtm, zNum, zLet);
                return routePlan;
            }
        }
        catch(e){
            const error = {
                timestamp: new Date().toISOString(),
                errorCode: 'E000',
                message: 'Route creation failed.',
                details: "The route could not be created due to an unknown error.\n"
                //                details: "The route could not be created due to an unknown error. Please try again or contact support if the issue persists.\n"

            };

            return error;  
        }

    }
    else{ // divide

        // TODO: llamar SingleOpenField para cada SubField

        var params3 = [];

        params3.polygonsUtm = polygonsUtm;
        params3.workingWidth = params.workingWidth; // (m)
        params3.workingSpeed = params.workingSpeed; // (m/s)
        params3.turningTime = 30; // (s)
        params3.areaCostCoefficient = params.areaCostCoefficient;
        params3.timeCostCoefficient = params.timeCostCoefficient;
        params3.thresholdRightAngle = params.thresholdRightAngle; // (degrees)
        params3.thresholdCollinearAngle = params.thresholdCollinearAngle; // (degrees)

        var subFields = getSubfields3(params3);

        //var subFields = subFields1.filter(sf => simplePolygonBuffer(sf.polygon, workingWidth/2).type === 'POLYGON');


        // Find the subfield containing the field's entrance and move it to the start of the array

        let dist = Infinity;
        let entranceSubField = null;
        for (let sf=0; sf<subFields.length;sf++){
            let d = distToPolygonSquared(utmEntrance, subFields[sf].polygon);
            if (d<dist){
                dist = d;
                entranceSubField = sf;
            }
        }
        subFields.unshift(...subFields.splice(entranceSubField, 1));


        const adjacency = buildAdjacencyGraph(subFields, workingWidth);

        const connections = adjacency.connections;
        const crossings = adjacency.crossings;

        const sequencer = new SubfieldsSequence(connections);

        // Ejecutamos el optimizador asumiendo que el punto de salida/entrada es el nodo 0
        const sfSequence = sequencer.solve(0);
        
        var params2=[];

        params2.obstaclesUtm = obstaclesUtm;
        params2.turningRadius = params.turningRadius; // (m)
        params2.workingWidth = params.workingWidth; // (m)
        params2.workingSpeed = params.workingSpeed; // (m/s)
        params2.internalPattern = params.internalPattern;
        params2.patternStart = "EndNearEntrance";
        params2.turnOffset = params.turnOffset;
        params2.turningSpeedPercentage = params.turningSpeedPercentage;
        params2.fullConcaveTurns = params.fullConcaveTurns; // boolean
        params2.circuitTurnsMinimumAngle = params.circuitTurnsMinimumAngle; // degrees
        params2.decreaseCircuitsAutomatically = true;
        params2.includeEntranceToStart = true; // boolean
        params2.includeEndToEntrance = true; // boolean
        params2.maxHeadlandCircuits = maxHeadlandCircuits;

        params2.utmEntrance = utmEntrance; // The entrance of the first route (last in the sequence) is the field's entrance
        params2.utmEntrance.zoneLetter = zLet;
        params2.utmEntrance.zoneNum = zNum;

        var routes = [];

        var joinedRoute = [];

        var transitSequenceEnd = null;
        var selectedCrossing = null;

        for (var seq = sfSequence.length-1; seq >= 0; seq--) {

            const sf = sfSequence[seq].id;
            const nextSf = seq < sfSequence.length-1 ? sfSequence[seq+1].id : null;
            const prevSf = seq > 0 ? sfSequence[seq-1].id : null;

            if (sfSequence[seq].w) {

                if (prevSf !== null){
                    params2.crossingsFromPreviousSf = {crossings:crossings[prevSf][sf]};
                } 
                
                var geoJsonPoly = ringToGeojsonPolygon(subFields[sf].polygon);
                var sp = simplifyAndNormalizePolygon(geoJsonPoly, 0.1);
                params2.polygonsUtm = [sp];
                params2.workingAngle = subFields[sf].workingAngle;

                try {
                    var rr = routeplannerSingleOpenField(params2);
                    if (rr.errorCode) {
                        console.log("Could not generate a route for the subfield " + sf + ". " + rr.message + "\n");
                    }
                    else {

                        // add connection between previous subfield and computed current subfield route

                        if (joinedRoute.length>0){

                            let connectionPolyline = [rr[rr.length-2], rr[rr.length-1]];
                            rr.pop();
                            connectionPolyline.push(joinedRoute[0]);
                            connectionPolyline.push(joinedRoute[1]);
                            joinedRoute.shift();

                            removeNearPoints(connectionPolyline,0.01); // remove duplicate consecutive points that may have been generated

                            removePolylineShortEdges(connectionPolyline, 0.3);

                            var connectionPath;
                            // en caso de que el primer punto de la ruta a la que se va a insertar el transit path por delante sea w='on'
                            // la curva que empalma debe ser "on" (esto sucede cuando hay un solo circuito y no hay mainfield)

                            if (joinedRoute[0].w=='off'){

                                // headlandPolylineToRoute does not add the first point
                                connectionPath = headlandPolylineToRoute(connectionPolyline, false, selectedCrossing.orientation, false, circuitTurnsMinimumAngle, true, turningRadius, turningSpeed, workingSpeed, workingWidth);

                                connectionPath.forEach(element => {
                                    element.w = "off";
                                });
                            }
                            else{
                                const connectionPathPolyline1 = connectionPolyline.slice(-3);
                                var connectionPath1 = headlandPolylineToRoute(connectionPathPolyline1, false, null, fullConcaveTurns, circuitTurnsMinimumAngle, false, turningRadius, turningSpeed, workingSpeed, workingWidth);

                                const connectionPathPolyline2 = connectionPolyline.slice(0, -1);
                                var connectionPath2 = headlandPolylineToRoute(connectionPathPolyline2, false, null, false, circuitTurnsMinimumAngle, true, turningRadius, turningSpeed, workingSpeed, workingWidth);
                                connectionPath2.pop();

                                connectionPath2.forEach(element => {
                                    element.w = "off";
                                });

                                connectionPath = [...connectionPath2, ...connectionPath1];
                            }

                            joinedRoute.unshift(...connectionPath);

                        }

                        joinedRoute.unshift(...rr);
                        const ind = params2.crossingsFromPreviousSf.selectedIndex;
                        //console.log("*** Sel Index ***: ", ind );
                        selectedCrossing = params2.crossingsFromPreviousSf.crossings[ind];
                        params2.utmEntrance = selectedCrossing.coordinates[0]; // set utmEntrance for next iteration = selectedCrossing first point
                    }
                }
                catch {
                    console.log("Could not generate a route for the subfield " + sf + " due to an unknown error.\n");
                }
            }
            else{ // transit sequence

                if (transitSequenceEnd == null) {
                    transitSequenceEnd = seq;
                };
                if (seq==0 || sfSequence[seq-1].w){
                    var transitPath = getTransitPath(seq, transitSequenceEnd, sfSequence, crossings, selectedCrossing, utmEntrance, subFields, params2.workingWidth, params2.circuitTurnsMinimumAngle, params2.turningRadius, turningSpeed, params2.workingSpeed, params2.fullConcaveTurns, [joinedRoute[0],joinedRoute[1]]); // param2.utmEntrance contains the selected entrance crossing for the subfield following the transit path sequence
                    joinedRoute.shift();
                    joinedRoute.unshift(... transitPath.path);
                    params2.utmEntrance = transitPath.initialCrossing.coord[0];
                    selectedCrossing = transitPath.initialCrossing;
                    transitSequenceEnd = null;
                }
                else{

                }

            }
/*
            var xxx=0;
            if (xxx==4){
                const routePlan = calculateRouteStats(joinedRoute, params2.workingWidth, polygonsUtm, zNum, zLet);
                return routePlan;
            }
*/
        }

        const routePlan = calculateRouteStats(joinedRoute, params2.workingWidth, polygonsUtm, zNum, zLet);
        return routePlan;


/*
        for (var sf=0; sf<subFields.length; sf++){

            var geoJsonPoly = ringToGeojsonPolygon(subFields[sf].polygon);
            var sp = simplifyAndNormalizePolygon(geoJsonPoly, 0.01);
            params2.polygonsUtm = [sp];
            params2.workingAngle = subFields[sf].workingAngle;
            params2.maxHeadlandCircuits = maxHeadlandCircuits;

            try{
                var rr = routeplannerSingleOpenField(params2);
                if (rr.errorCode){
                    console.log("Could not generate a route for the subfield " + sf + ". " + rr.message + "\n");
                }
                else{
                    routes.push(rr);
                }
            }
            catch {
                console.log("Could not generate a route for the subfield " + sf + " due to an unknown error.\n");
            }
        }
*/
        if (routes.length==0){  // there is no space even for the first subField attempt
            
            const error = {
                timestamp: new Date().toISOString(),
                errorCode: 'E011',
                message: 'No route could be generated for any subfield.',
                details: "A route could not be generated for any of the " + subFields.length + " subfields. Please review the field layout and settings, then try again.\n"
                //                details: "The route could not be created due to an unknown error. Please try again or contact support if the issue persists.\n"

            };

            return error;
        }

        // compute statistics for the combination of all subroutes

        var coveredArea=[];
        var overlapArea=[];
        var uncoveredArea=[];
        var travelledDistance=0;
        var workedDistance=0;
        var travelledTime=0;
        var workedTime=0;
        var coveredAreaSizeM2=0;
        var overlapAreaSizeM2=0;
        var uncoveredAreaSizeM2=0;

        for (var r=0; r<routes.length; r++){
            coveredArea.push(...routes[r].routeStats.coveredArea);
            overlapArea.push(...routes[r].routeStats.overlapArea);
            uncoveredArea.push(...routes[r].routeStats.uncoveredArea);
            travelledDistance += routes[r].routeStats.travelledDistance;
            workedDistance += routes[r].routeStats.workedDistance;
            travelledTime += routes[r].routeStats.travelledTime;
            workedTime +=routes[r].routeStats.workedTime;
            coveredAreaSizeM2 += routes[r].routeStats.coveredAreaSizeM2;
            overlapAreaSizeM2 += routes[r].routeStats.overlapAreaSizeM2;
            uncoveredAreaSizeM2 += routes[r].routeStats.uncoveredAreaSizeM2;
        }

        var fieldSizeM2 = polygonArea(polygonsUtm[0]);
        //subtract exclusion areas
        for (var h=1; h<polygonsUtm.length; h++){
            fieldSizeM2 -= polygonArea(polygonsUtm[h]);
        }

        var stats = {
            coveredArea: coveredArea,
            overlapArea: overlapArea,
            uncoveredArea: uncoveredArea,
            coveredAreaSize: (100*coveredAreaSizeM2/fieldSizeM2).toFixed(2),
            uncoveredAreaSize: (100*(fieldSizeM2-coveredAreaSizeM2)/fieldSizeM2).toFixed(2),
            overlapAreaSize: (100*overlapAreaSizeM2/fieldSizeM2).toFixed(2),
            travelledDistance: travelledDistance,
            workedDistance:workedDistance,
            travelledTime: travelledTime,
            workedTime: workedTime
        }

        routes[0].routeStats = stats;

        // put the combined statistics in the first subroute and delete the rest
        for (var r=1; r<routes.length; r++){
            routes[r].routeStats = {};
        }

        return routes;

    }

}


function calculateNumberOfCircuits(polygon, maxNumberOfCircuits, workingWidth){

    var ringGeoJson = ringToGeojsonPolygon(polygon);

    for (var n=maxNumberOfCircuits; n>0; n--){
        var mainland = polygonBuffer(ringGeoJson, n*workingWidth).coordinates;
        if (mainland.length>0){
            break;
        }
    }

    return n; // if n=0 there is no space to calculate a route
}

function calculateNumberOfCircuits_old(polygon, maxNumberOfCircuits, workingWidth){

    // la aproximacion del área mayor a (2*workingwidth)^2 no sirve.
    // hay que calcular el ancho maximo del poligono (en getSubFields.js, antes de ser rotado) 
    // y sin hacer buffer, tomar que el ancho del poligono debe ser > (2*n+1)*workingwidth

    var ringGeoJson = ringToGeojsonPolygon(polygon);
    var minArea = (2*workingWidth)**2; // TODO: buscar un método más preciso para buscar area minima. Tal vez examinar la forma tambien

    for (var n=maxNumberOfCircuits; n>0; n--){
        var mainland = polygonBuffer(ringGeoJson, n*workingWidth).coordinates;
        if (polygonArea(mainland)>minArea){
            break;
        }
    }

    return n; // if n=0 there is no space to calculate a route
}

function validateParams(params){

    // fieldPolygon: (*)

    if (typeof params.fieldPolygon === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(), // Fecha y hora del error en formato ISO
            errorCode: 'E001',               // Código de error personalizado
            message: 'Missing parameter', // Mensaje principal del error
            details: 'The "fieldPolygon" parameter is required but was not provided.' // Descripción más técnica
            // level: The severity of the error (e.g., "error", "warning", "info")
          };

        return error;
    }

    if (!isValidArrayOfEvenLengthArrays(params.fieldPolygon)){

        const error = {
            timestamp: new Date().toISOString(), // Fecha y hora del error en formato ISO
            errorCode: 'E002',               // Código de error personalizado
            message: 'Invalid parameter format', // Mensaje principal del error
            details: 'The format of the "fieldPolygon" parameter is incorrect. Please ensure it follows the expected structure.' // Descripción más técnica
            // level: The severity of the error (e.g., "error", "warning", "info")
          };

          return error;
    }


    // obstacles:

    if (typeof params.obstacles === 'undefined') {
        params.obstacles = [];
    }

    if (!isValidArrayOfEvenLengthArrays(params.obstacles)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'The format of the "obstacles" parameter is incorrect. Please ensure it follows the expected structure.'
          };

          return error;
    }

    // turningRadius: 3, // (m)  (*)

    if (typeof params.turningRadius === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E001',              
            message: 'Missing parameter', 
            details: 'The "turningRadius" parameter is required but was not provided.'
          };

        return error;
    }

    if (!isNumeric(params.turningRadius)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "turningRadius" must be a numeric value.'
          };

          return error;
    }

    if (!(params.turningRadius>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "turningRadius" must be greater than or equal to zero.' 
          };

          return error;
    }

    // workingWidth: 6, // (m)  (*)

    if (typeof params.workingWidth === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E001',              
            message: 'Missing parameter', 
            details: 'The "workingWidth" parameter is required but was not provided.'
          };

        return error;
    }

    if (!isNumeric(params.workingWidth)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "workingWidth" must be a numeric value.'
          };

          return error;
    }

    if (!(params.workingWidth>0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "workingWidth" must be greater than zero.' 
          };

          return error;
    }

    // workingSpeed: 2.2, // (m/s)  (*)

    if (typeof params.workingSpeed === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E001',              
            message: 'Missing parameter', 
            details: 'The "workingSpeed" parameter is required but was not provided.'
          };

        return error;
    }

    if (!isNumeric(params.workingSpeed)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "workingSpeed" must be a numeric value.'
          };

          return error;
    }

    if (!(params.workingSpeed>0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "workingSpeed" must be greater than zero.' 
          };

          return error;
    }

    // maxHeadlandCircuits: 5, // (N) (*)

    if (typeof params.headlandCircuits === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E001',              
            message: 'Missing parameter', 
            details: 'The "headlandCircuits" parameter is required but was not provided.'
          };

        return error;
    }

    if (!Number.isInteger(params.headlandCircuits)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "headlandCircuits" must be an integer value.'
          };

          return error;
    }

    if (!(params.headlandCircuits>0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "headlandCircuits" must be greater than zero.' 
          };

          return error;
    }

    // fieldEntrance: [-2.687776316314259, 53.017753154423424],

    if (typeof params.fieldEntrance === 'undefined') {
        params.fieldEntrance = [params.fieldPolygon[0][0], params.fieldPolygon[0][1]];
    }

    if (!isValidNumericPair(params.fieldEntrance)){

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E002',
            message: 'Invalid parameter format',
            details: 'The format of the "fieldEntrance" parameter is incorrect. Please ensure it follows the expected structure.'
          };

          return error;
    }

    // internalPattern: "SFP3", // "SAP" | "SFP3" | "SFP5" | "SFP7"

    if (typeof params.internalPattern === 'undefined') {
        params.internalPattern = "SAP";
    }

    if (!(typeof params.internalPattern === 'string')) {

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E002',
            message: 'Invalid parameter format',
            details: 'Invalid format: "internalPattern" must be a string.'
          };

          return error;
    }

    if (!isValidInternalPattern(params.internalPattern)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "internalPattern" must be a string with one of the following values: "SAP", "SFP3", "SFP5", or "SFP7".' 
          };

          return error;
    }

    // patternStart: "EndNearEntrance",

    if (typeof params.patternStart === 'undefined') {
        params.patternStart = "SAP";
    }

    if (!(typeof params.patternStart === 'string')) {

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E002',
            message: 'Invalid parameter format',
            details: 'Invalid format: "patternStart" must be a string.'
          };

          return error;
    }

    if (!isValidPatternStart(params.patternStart)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "patternStart" must be a string with one of the following values: "EndNearEntrance" or "StartNearEntrance".' 
          };

          return error;
    }

    // turnOffset: 0,

    if (typeof params.turnOffset === 'undefined') {
        params.turnOffset = 0;
    }

    if (!isNumeric(params.turnOffset)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "turnOffset" must be a numeric value.'
          };

          return error;
    }

    if (!(params.turnOffset>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "turnOffset" must be greater than or equal to zero.' 
          };

          return error;
    }

    // turningSpeedPercentage: 50,

    if (typeof params.turningSpeedPercentage === 'undefined') {
        params.turningSpeedPercentage = 50;
    }

    if (!isNumeric(params.turningSpeedPercentage)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "turningSpeedPercentage" must be a numeric value.'
          };

          return error;
    }

    if (!(params.turningSpeedPercentage>0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "turningSpeedPercentage" must be greater than zero.' 
          };

          return error;
    }

    // fullConcaveTurns: true, // boolean

    if (typeof params.fullConcaveTurns === 'undefined') {
        params.fullConcaveTurns = true;
    }

    if (!(typeof params.fullConcaveTurns === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "fullConcaveTurns" must be a boolean value.'
          };

          return error;
    }

    // circuitTurnsMinimumAngle: 25, // degrees

    if (typeof params.circuitTurnsMinimumAngle === 'undefined') {
        params.circuitTurnsMinimumAngle = 25;
    }

    if (!isNumeric(params.circuitTurnsMinimumAngle)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "circuitTurnsMinimumAngle" must be a numeric value.'
          };

          return error;
    }

    if (!(params.circuitTurnsMinimumAngle>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "circuitTurnsMinimumAngle" must be greater than or equal to zero.' 
          };

          return error;
    }

    // workingAngle: "OPTIMAL", // "OPTIMAL", // used only if subvidide=false. "OPTIMAL", "LONGEST_SIDE" or numeric value in degrees (0-180)

    if (typeof params.workingAngle === 'undefined') {

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E001',
            message: 'Missing parameter',
            details: 'The "workingAngle" parameter is required but was not provided.'
          };

        return error;
    }

    if (!isValidWorkingAngle(params.workingAngle)){

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E002',
            message: 'Invalid parameter format',
            details: 'The format of the "workingAngle" parameter is incorrect. It must be a numeric value or one of the following strings: "OPTIMAL" or "LONGEST_SIDE".'
          };

          return error;
    }

    // subdivide: true, // boolean

    if (typeof params.subdivide === 'undefined') {
        params.subdivide = false;
    }

    if (!(typeof params.subdivide === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "subdivide" must be a boolean value.'
          };

          return error;
    }

    // areaCostCoefficient: 0.1, // used only if subdivide=true

    if (typeof params.areaCostCoefficient === 'undefined') {
        params.areaCostCoefficient = 0.5;
    }

    if (!isNumeric(params.areaCostCoefficient)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "areaCostCoefficient" must be a numeric value.'
          };

          return error;
    }

    if (!(params.areaCostCoefficient>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "areaCostCoefficient" must be greater than or equal to zero.' 
          };

          return error;
    }

    // timeCostCoefficient: 0.5, // used only if subdivide=true

    if (typeof params.timeCostCoefficient === 'undefined') {
        params.timeCostCoefficient = 0.5;
    }

    if (!isNumeric(params.timeCostCoefficient)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "timeCostCoefficient" must be a numeric value.'
          };

          return error;
    }

    if (!(params.timeCostCoefficient>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "timeCostCoefficient" must be greater than or equal to zero.' 
          };

          return error;
    }

    // thresholdRightAngle: 70, // used only if subdivide=true (degrees)

    if (typeof params.thresholdRightAngle === 'undefined') {
        params.thresholdRightAngle = 75;
    }

    if (!isNumeric(params.thresholdRightAngle)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "thresholdRightAngle" must be a numeric value.'
          };

          return error;
    }

    if (!(params.thresholdRightAngle>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "thresholdRightAngle" must be greater than or equal to zero.' 
          };

          return error;
    }

    // thresholdCollinearAngle: 70 // used only if subdivide=true (degrees)   

    if (typeof params.thresholdCollinearAngle === 'undefined') {
        params.thresholdCollinearAngle = 75;
    }

    if (!isNumeric(params.thresholdCollinearAngle)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "thresholdCollinearAngle" must be a numeric value.'
          };

          return error;
    }

    if (!(params.thresholdCollinearAngle>=0)){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E003',              
            message: 'Invalid parameter value', 
            details: 'Invalid value: "thresholdCollinearAngle" must be greater than or equal to zero.' 
          };

          return error;
    }

    // decreaseCircuitsAutomatically // boolean

    if (typeof params.decreaseCircuitsAutomatically === 'undefined') {
        params.decreaseCircuitsAutomatically = false;
    }

    if (!(typeof params.decreaseCircuitsAutomatically === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "decreaseCircuitsAutomatically" must be a boolean value.'
          };

          return error;
    }


    // increaseCircuitsAutomatically // boolean

    if (typeof params.increaseCircuitsAutomatically === 'undefined') {
        params.increaseCircuitsAutomatically = false;
    }

    if (!(typeof params.increaseCircuitsAutomatically === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "increaseCircuitsAutomatically" must be a boolean value.'
          };

          return error;
    }

    // includeEntranceToStart; // boolean

    if (typeof params.includeEntranceToStart === 'undefined') {
        params.includeEntranceToStart = true;
    }

    if (!(typeof params.includeEntranceToStart === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "includeEntranceToStart" must be a boolean value.'
          };

          return error;
    }

    // includeEndToEntrance; // boolean

    if (typeof params.includeEndToEntrance === 'undefined') {
        params.includeEndToEntrance = true;
    }

    if (!(typeof params.includeEndToEntrance === 'boolean' )){

        const error = {
            timestamp: new Date().toISOString(), 
            errorCode: 'E002',              
            message: 'Invalid parameter format', 
            details: 'Invalid format: "includeEndToEntrance" must be a boolean value.'
          };

          return error;
    }

    return null;


}



const isValidArrayOfEvenLengthArrays = (input) => {
    // Verifica que input sea un array
    if (!Array.isArray(input)) return false;

    return input.every(sub =>
        Array.isArray(sub) &&
        sub.every(item => typeof item === 'number') &&
        sub.length % 2 === 0
    );

    // Ejemplo de uso:
    //   const test1 = [[1, 2], [3, 4, 5, 6]];       // ✅ válido
    //   const test2 = [[1, 2, 3], [4, 5]];          // ❌ uno tiene longitud impar
    //   const test3 = [[1, 2], ['a', 'b']];         // ❌ contiene strings
    //   const test4 = 'not an array';              // ❌ no es un array

    //   console.log(isValidArrayOfEvenLengthArrays(test1)); // true
    //   console.log(isValidArrayOfEvenLengthArrays(test2)); // false
    //   console.log(isValidArrayOfEvenLengthArrays(test3)); // false
    //   console.log(isValidArrayOfEvenLengthArrays(test4)); // false

};
  
const isNumeric = valor => {
    return !isNaN(parseFloat(valor)) && isFinite(valor);
};

const isValidWorkingAngle = valor => {
    const validStrings = ["OPTIMAL", "LONGEST_SIDE"];
    return (!isNaN(parseFloat(valor)) && isFinite(valor)) || validStrings.includes(valor);

    // console.log(esValido(42));             // true
    // console.log(esValido("123.45"));       // true
    // console.log(esValido("OPTIMAL"));      // true
    // console.log(esValido("LONGEST_SIDE")); // true

};

const isValidInternalPattern = valor => {
    const validStrings = ["SAP", "SFP3", "SFP5", "SFP7"];
    return typeof valor === "string" && validStrings.includes(valor);
};

const isValidPatternStart = valor => {
    const validStrings = ["StartNearEntrance", "EndNearEntrance"];
    return typeof valor === "string" && validStrings.includes(valor);
};

const isValidNumericPair = (value) => {
    return (
        Array.isArray(value) &&
        value.length === 2 &&
        value.every(item => typeof item === 'number' && !isNaN(item))
    );
};

/*

function calculateOptimalWorkingAngle(polygon, numberOfCircuits, workingWidth){

    var ringGeoJson = ringToGeojsonPolygon(polygon);
    var mainland = polygonBuffer(ringGeoJson, numberOfCircuits*workingWidth).coordinates;

    var rotationPoint = mainland[0];

    var optimalAngle = null;
    var smallerWidth = Infinity;
    for (var angle=0; angle<180; angle++){

        var rotatedPolygon = rotatePolygon(mainland, rotationPoint, (90-angle) * Math.PI/180);

        if (isXMonotone(rotatedPolygon)){
            var xMin =Math.min.apply(Math, rotatedPolygon.map(function(o) { return o.x; })) // minimum x value of all polygon points
            var xMax =Math.max.apply(Math, rotatedPolygon.map(function(o) { return o.x; })) // maximum x value of all polygon points
        
            if ( (xMax-xMin)<smallerWidth ){
                smallerWidth = xMax-xMin;
                optimalAngle = angle;
            }
        }
    }

    return optimalAngle;

}

function isMonotone(polygon, numberOfCircuits, workingWidth, angle){ 

    // check if the polygon is monotone for a certain angle
    var ringGeoJson = ringToGeojsonPolygon(polygon);
    var mainland = polygonBuffer(ringGeoJson, numberOfCircuits*workingWidth).coordinates;

    var rotationPoint = mainland[0];

    var rotatedPolygon = rotatePolygon(mainland, rotationPoint, (90-angle) * Math.PI/180);

    return isXMonotone(rotatedPolygon);
}
*/

function graficar1(pol){
    var str="";
    for (var j=0; j<pol.length; j++){

        str +=  pol[j].x + ',' + pol[j].y + '\n';

    }
    str +=  pol[0].x + ',' + pol[0].y + '\n';
    str += '\n';
    return str;
}

function calculateRouteStats(route, workingWidth, polygonsUtm, zNum, zLet){

    // convert back UTM to LatLon


    // compute time
    var travelledDistance=0;
    var workedDistance=0;
    var travelledTime=0;
    var workedTime=0;

    route[0].time = 0;
    for (var p=1; p<route.length; p++){
        var dx = route[p].x - route[p-1].x;
        var dy = route[p].y - route[p-1].y;
        var distToPrevWp = Math.sqrt(dx*dx + dy*dy);
        var dt = distToPrevWp/Math.abs(route[p-1].speed);
        travelledTime += dt;
        if (route[p-1].w == "on") {
            workedTime += dt;
        }
        travelledDistance += distToPrevWp;
        if (route[p-1].w == "on") {
            workedDistance += distToPrevWp;
        }
        route[p].time = travelledTime;
    }

    // compute coverage areas before converting from UTM to LL

    var coverageAreas = [];
    var coverageAreasUtm = []; // covered rectangles in UTM to compute total covered area, uncovered area and overlap area
    
    for (var p=0; p<route.length-1; p++){

        if (route[p].w == "on"){

            try{
                // compute rectangle coords

                var dx = route[p+1].x - route[p].x;
                var dy = route[p+1].y - route[p].y;
                var angle = Math.atan2(dy,dx);

                // rectangle: P1->P2->P4->P3  
                var P1 = { x: Math.sin(angle) * workingWidth/2 + route[p].x , y: -Math.cos(angle) * workingWidth/2 + route[p].y };
                var P2 = { x: -Math.sin(angle) * workingWidth/2 + route[p].x , y: Math.cos(angle) * workingWidth/2 + route[p].y };
                var P3 = { x: Math.sin(angle) * workingWidth/2 + route[p+1].x , y: -Math.cos(angle) * workingWidth/2 + route[p+1].y };
                var P4 = { x: -Math.sin(angle) * workingWidth/2 + route[p+1].x , y: Math.cos(angle) * workingWidth/2 + route[p+1].y };

                coverageAreasUtm.push([P1,P2,P4,P3]);

                var rectLatLon = toLatLonArray2([P1,P2,P4,P3], zNum, zLet);

                var covArea = {wp: p, coords: rectLatLon, startTime: route[p].time, endTime: route[p+1].time };

                coverageAreas.push(covArea);
            }catch(e){

            }

        }
    }

    try{
        var routeStats = computeAreas(polygonsUtm, coverageAreasUtm);
    }
    catch{

        const error = {
            timestamp: new Date().toISOString(),
            errorCode: 'E012',
            message: 'Error calculating statistical areas.',
            details: "An unexpected error occurred while calculating the statistical areas.\n"
        };

        return error;
    }


    // convert different areas to LatLon
    // Each area is an array of polygons, each polygon is an array of ring coordinates: first element is the exterior ring, rest are holes

    var coveredAreaLatLon = []; 
    for (var pol=0; pol<routeStats.coveredArea.length; pol++){
        var ringsLatLon = [];
        for (var ring=0; ring<routeStats.coveredArea[pol].length; ring++){
            ringsLatLon.push(toLatLonArray2(routeStats.coveredArea[pol][ring], zNum, zLet));
        }
        coveredAreaLatLon.push(ringsLatLon);
    }

    var overlapAreaLatLon = []; 
    for (var pol=0; pol<routeStats.overlapArea.length; pol++){
        var ringsLatLon = [];
        for (var ring=0; ring<routeStats.overlapArea[pol].length; ring++){
            ringsLatLon.push(toLatLonArray2(routeStats.overlapArea[pol][ring], zNum, zLet));
        }
        overlapAreaLatLon.push(ringsLatLon);
    }

    var uncoveredAreaLatLon = []; 
    for (var pol=0; pol<routeStats.uncoveredArea.length; pol++){
        var ringsLatLon = [];
        for (var ring=0; ring<routeStats.uncoveredArea[pol].length; ring++){
            ringsLatLon.push(toLatLonArray2(routeStats.uncoveredArea[pol][ring], zNum, zLet));
        }
        uncoveredAreaLatLon.push(ringsLatLon);
    }

    // replace areas by LatLon version
    routeStats.coveredArea = coveredAreaLatLon;
    routeStats.uncoveredArea = uncoveredAreaLatLon;
    routeStats.overlapArea = overlapAreaLatLon;

    routeStats.travelledDistance = travelledDistance;
    routeStats.workedDistance = workedDistance;
    routeStats.travelledTime = travelledTime;
    routeStats.workedTime = workedTime;
    
    var rLatLon = toLatLonArray2(route, zNum, zLet);
    //routes.push(rLatLon); 

    //var rotatedSpiral = rotatePolygon(headlandSpiralRoute, rotationPoint, -(90-workingAngle) * Math.PI/180);
    //var rLatLon2 = toLatLonArray2(rotatedSpiral, zNum, zLet);

    //rLatLon.push(... rLatLon2);
    //var sarasa = graficar1(regionRoute);

    /*
    for (var n=0; n<hheadlandRings.length; n++){
        if (hheadlandRings[n].length>=2){
            var routeLatLon = toLatLonArray2(hheadlandRings[n], zNum, zLet);
            // add last point equal to first one
            routeLatLon.push(routeLatLon[0]);
            routeLatLon.push(routeLatLon[1]);
            routes.push(routeLatLon);
        }
    }
    */

    var speedArray = route.map(a => a.speed);
    var workArray = route.map(a => a.w);
    var timeArray = route.map(a => a.time);

    var routePlan = {routesCoord: rLatLon, // TODO: change to simple array when subroutes merged in unique route
        time: timeArray,
        speed: speedArray,
        work: workArray,
        coverageAreas: coverageAreas,
        routeStats: routeStats
    };

    return routePlan;

}

function getTransitPath(transitSequenceInit, transitSequenceEnd, sfSequence, crossings, crossingToNextRoute, fieldUtmEntrance, subFields, workingWidth, circuitTurnsMinimumAngle, turningRadius, turningSpeed, workingSpeed, fullConcaveTurns, joinedRouteStart){

    var transitPathPolyline = [];
    var transitPath = [];

    // build transit path
    const graphLayers = [];
    const edgeDistances = {};
    var level = 0;
    graphLayers[level] = [];


    // level 0:

    if (transitSequenceInit==0){ // If it is the first step of the general sequence, the subfield is 0 and the only starting point is the field entrance
        var node = {};
        node.name = "fieldEntrance";
        node.coord = [fieldUtmEntrance];
        graphLayers[level].push(node);
    }
    else{
        // Get the subfield entrance crossings
        var currentSubField = sfSequence[transitSequenceInit].id;
        var previousSubField = sfSequence[transitSequenceInit-1].id;
        var crossingsLevel0 = crossings[previousSubField][currentSubField];

        for (let cr = 0; cr<crossingsLevel0.length; cr++){
            var node = {};
            node.name = "crossing_" + previousSubField + "_" + currentSubField + "_" + cr;
            node.coord = crossingsLevel0[cr].coordinates;
            node.orientation = crossingsLevel0[cr].orientation;
            graphLayers[level].push(node);
        }

    }


    for (var seq=transitSequenceInit; seq<=transitSequenceEnd; seq++){

        level++;
        graphLayers[level] = [];

        // Get the subfield output crossings
        var currentSubField = sfSequence[seq].id;
        
        if (seq<transitSequenceEnd){
            var nextSubField = sfSequence[seq+1].id;
            var crossingsLevel = crossings[currentSubField][nextSubField];

            for (let cr = 0; cr<crossingsLevel.length; cr++){
                var node = {};
                node.name = "crossing_" + currentSubField + "_" + nextSubField + "_" + cr;
                node.coord = crossingsLevel[cr].coordinates;
                node.orientation = crossingsLevel[cr].orientation;
                graphLayers[level].push(node);
            }
        }
        else{ // Final subfield in the transit sequence. The exit crossing is the one selected to start the next worked subfield

            var node = {};
            node.name = "exitCrossing";
            node.coord = crossingToNextRoute.coordinates;
            node.orientation = crossingToNextRoute.orientation;
            graphLayers[level].push(node);

        }

        const crossingsFromPrevious = graphLayers[level-1];
        const crossingsToNext = graphLayers[level];

        // Recorrer nodos previos anidado con nodos next y calcular las 4 distancias

        for (let cp=0; cp<crossingsFromPrevious.length; cp++){
            for (let cn=0; cn<crossingsToNext.length; cn++){

                // para cada prev-next nodos calcular las distancias CW y CCW
                // quedarse con la menor de las dos, y guardar el dato CW/CCW de 'orientation' en el nodo inicio?

                const pStart = crossingsFromPrevious[cp].coord[crossingsFromPrevious[cp].coord.length-1];
                const pEnd = crossingsToNext[cn].coord[0];
                const pol = subFields[currentSubField].polygon;
                const circuit = simplePolygonBuffer(pol, workingWidth/2);

                const dcr = distanceAroundPolygon(pStart, pEnd, circuit.coordinates);
                const mindcr = Math.min(dcr.cw, dcr.ccw);
                const orientation = dcr.cw < dcr.ccw ? 'CW' : 'CCW';

                const key = crossingsFromPrevious[cp].name + "-" + crossingsToNext[cn].name;
                const value = { d: mindcr, o: orientation };

                edgeDistances[key] = value;
            }
        }
       
    }

    const layers = graphLayers.map(subArray =>
        subArray.map(obj => obj.name)
    );

    const path = findShortestPath(layers, edgeDistances);

    const pathSteps = path.pathString.split(" -> ");

    let pathInitialCrossing;

    for (let step=0; step<pathSteps.length-1; step++){

        const splitOrientation = pathSteps[step+1].split("-");
        const orientation = splitOrientation[1];
        pathSteps[step+1] = splitOrientation[0];

        // find crossing selected by findShortestPath in graphLayers

        const startCrossing = graphLayers[step].find(p => p.name === pathSteps[step]);
        const endCrossing = graphLayers[step+1].find(p => p.name === pathSteps[step+1]);

        if (step==0){
            pathInitialCrossing = startCrossing;
        }

        const subFld = sfSequence[transitSequenceInit + step].id;
        const pol = subFields[subFld].polygon;
        const circuit = simplePolygonBuffer(pol, workingWidth/2);

        //const previousToStartPoint = {...startCrossing.coord[0], orientation: startCrossing.orientation};
        // find closest point to entrance crossing on polygon
        const startPoint = closestPointInPolygon2(startCrossing.coord[startCrossing.coord.length-1], circuit.coordinates); // last point of entrance crossing
        startPoint.point.orientation = startCrossing.orientation;

        const startPointSegmentNumber = startPoint.segmentNumber;
 
        let rotatedPts = arrayRotate(circuit.coordinates.slice(0), startPointSegmentNumber);

        const endPoint = closestPointInPolygon2(endCrossing.coord[0], rotatedPts); // first point of exit crossing
        endPoint.point.orientation = endCrossing.orientation;

        var intermediatePts = [];

        if (endPoint.segmentNumber != 0) {

            if (orientation == 'CCW') {
                try {
                    rotatedPts = arrayRotate(rotatedPts.slice(0), 2);
                }
                catch (e) {
                    var asdf = 0;
                }
                rotatedPts.reverse();
                endPoint.segmentNumber = circuit.coordinates.length - endPoint.segmentNumber;
            }

            for (var i = 0; i < endPoint.segmentNumber; i++) {
                intermediatePts.push({...rotatedPts[i + 1], orientation: orientation});
            }
        }

        //rotatedPts.splice(endPoint.segmentNumber);

        //if (step > 0) {  // At the beginning of the route, the previousToStartPoint is the field entrance and should not be added. The startPoint is also excluded because there is no two-point crossing -only the point closest to the entrance-
            //transitPathPolyline.push(previousToStartPoint);  // 
        //}

        if (intermediatePts.length==0 || intermediatePts.length>0 && distancePointPoint(startPoint.point, intermediatePts[0])>0.1){
            transitPathPolyline.push(startPoint.point);
        }

        transitPathPolyline.push(...intermediatePts);

        if (intermediatePts.length==0 || intermediatePts.length>0 && distancePointPoint(endPoint.point, intermediatePts[intermediatePts.length-1])>0.1){
            transitPathPolyline.push(endPoint.point);
        }

        joinedRouteStart[0].orientation = endPoint.point.orientation;
        joinedRouteStart[1].orientation = endPoint.point.orientation;
    }

    transitPathPolyline.push(...joinedRouteStart);

    removeNearPoints(transitPathPolyline,0.01); // remove duplicate consecutive points that may have been generated

    removePolylineShortEdges(transitPathPolyline, 0.3);


    // en caso de que el primer punto de la ruta a la que se va a insertar el transit path por delante sea w='on'
    // la curva que empalma debe ser "on" (esto sucede cuando hay un solo circuito y no hay mainfield)

    if (joinedRouteStart[0].w=='off'){

        // headlandPolylineToRoute does not add the first point
        transitPath = headlandPolylineToRoute(transitPathPolyline, false, null, false, circuitTurnsMinimumAngle, true, turningRadius, turningSpeed, workingSpeed, workingWidth);

        const firstPt = transitPathPolyline[0];
        firstPt.w = "off";
        firstPt.speed = workingSpeed;
        //transitPath.pop();
        transitPath.unshift(firstPt);

        transitPath.forEach(element => {
            element.w = "off";
        });
    }
    else{

        const transitPathPolyline1 = transitPathPolyline.slice(-3);
        var transitPath1 = headlandPolylineToRoute(transitPathPolyline1, false, null, fullConcaveTurns, circuitTurnsMinimumAngle, false, turningRadius, turningSpeed, workingSpeed, workingWidth);

        const transitPathPolyline2 = transitPathPolyline.slice(0, -1);
        var transitPath2 = headlandPolylineToRoute(transitPathPolyline2, false, null, false, circuitTurnsMinimumAngle, true, turningRadius, turningSpeed, workingSpeed, workingWidth);
        transitPath2.pop();

        transitPath2.forEach(element => {
            element.w = "off";
        });

        transitPath = [...transitPath2, ...transitPath1];

        const firstPt = transitPathPolyline2[0];
        firstPt.w = "off";
        firstPt.speed = workingSpeed;
        transitPath.unshift(firstPt);

    }
    
    return {path:transitPath, initialCrossing:pathInitialCrossing};

}

/**
 * Finds the optimal path in a layered graph including metadata (orientation).
 * @param {Array<Array<number>>} layers - Array of levels with node IDs.
 * @param {Object} edgeData - Map where keys are "from-to" and values are {d: distance, o: orientation}.
 * @returns {Object} - Object containing the final distance and the formatted path string.
 */
const findShortestPath = (layers, edgeData) => {
    // dp[level][node] = { totalDist, fullPath: [{ node, label }, ...] }
    const dp = [];

    // 1. Initialize the first level (Step 0)
    dp[0] = {};
    layers[0].forEach(node => {
        // The starting node has no previous label (null)
        dp[0][node] = {
            totalDist: 0,
            fullPath: [{ node, label: null }]
        };
    });

    // 2. Process each subsequent level
    for (let i = 1; i < layers.length; i++) {
        dp[i] = {};
        const currentLevelNodes = layers[i];
        const previousLevelNodes = layers[i - 1];

        currentLevelNodes.forEach(currNode => {
            let minDistance = Infinity;
            let bestPathForNode = [];

            previousLevelNodes.forEach(prevNode => {
                const edge = edgeData[`${prevNode}-${currNode}`];

                // Skip if there is no connection between these nodes
                if (edge) {
                    const currentTotal = dp[i - 1][prevNode].totalDist + edge.d;

                    if (currentTotal < minDistance) {
                        minDistance = currentTotal;
                        // Append the new node and its connection metadata (o)
                        bestPathForNode = [
                            ...dp[i - 1][prevNode].fullPath,
                            { node: currNode, label: edge.o }
                        ];
                    }
                }
            });

            dp[i][currNode] = {
                totalDist: minDistance,
                fullPath: bestPathForNode
            };
        });
    }

    // 3. Extract the final result from the last level
    const lastLevel = dp[dp.length - 1];
    const optimalResult = Object.values(lastLevel).reduce((best, current) => {
        return current.totalDist < best.totalDist ? current : best;
    }, { totalDist: Infinity, fullPath: [] });

    // 4. Format the path as a string: "node -> node-label -> node-label"
    const formattedPath = optimalResult.fullPath
        .map((step, index) => {
            // First node doesn't have a label in the output
            return index === 0 ? step.node : `${step.node}-${step.label}`;
        })
        .join(" -> ");

    return {
        totalDistance: optimalResult.totalDist,
        pathString: formattedPath
    };
};

/*
// --- Test Data ---

const layers = [
    [0, 1],
    [2, 3],
    [4, 5],
    [6]
];

const edgeDistances = {
    // From Level 0 to 1
    "0-2": { d: 10, o: "CW" }, "0-3": { d: 5, o: "CCW" },
    "1-2": { d: 2, o: "CCW" }, "1-3": { d: 8, o: "CW" },
    // From Level 1 to 2
    "2-4": { d: 4, o: "CCW" }, "2-5": { d: 7, o: "CCW" },
    "3-4": { d: 6, o: "CW" }, "3-5": { d: 1, o: "CW" },
    // From Level 2 to 3
    "4-6": { d: 3, o: "CW" },
    "5-6": { d: 5, o: "CCW" }
};

const result = findShortestPath(layers, edgeDistances);

console.log("Optimal Distance:", result.totalDistance);
console.log("Formatted Path:", result.pathString);
*/


function arrayRotate(arr, count) {
    count -= arr.length * Math.floor(count / arr.length);
    arr.push.apply(arr, arr.splice(0, count));
    return arr;
}

